/* GENERATED by scripts/assets/extract-sprite.mjs - do not edit. */
import { createElement, Fragment, type ReactNode } from "react";

import type { IconName } from "./icon-names.ts";

export const GLYPH_RENDERERS: { readonly [K in IconName]: () => ReactNode } = {
  "badge-critical": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 2.6 22 19.4a1.9 1.9 0 0 1-1.65 2.9H3.65A1.9 1.9 0 0 1 2 19.4L12 2.6Z", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M12 9.2v4.6", "fill": "none", "stroke": "var(--badge-core, #ffffff)", "strokeWidth": "2.3", "strokeLinecap": "round" }),
    createElement("circle", { "cx": "12", "cy": "17.6", "r": "1.35", "fill": "var(--badge-core, #ffffff)", "stroke": "none" })
    )
  ),
  "badge-proof": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "7.4", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "m8.7 12.2 2.2 2.2 4.4-4.7", "fill": "none", "stroke": "var(--pin-core, #ffffff)", "strokeWidth": "2.1", "strokeLinecap": "round", "strokeLinejoin": "round" })
    )
  ),
  "acknowledge": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M20.6 14.6a1.8 1.8 0 0 1-1.8 1.8H9l-4.6 4V6.2a1.8 1.8 0 0 1 1.8-1.8h12.6a1.8 1.8 0 0 1 1.8 1.8Z" }),
    createElement("path", { "d": "m8.8 10.6 2.4 2.4 4.4-4.8" })
    )
  ),
  "admin": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "M16.6 11.2a2.6 2.6 0 1 0 0-5.2" }),
    createElement("path", { "d": "M17.4 19.4c-.2-1.4-.6-2.6-1.3-3.5 2.2-.4 4.1 1 4.5 3.5" })
    )
  ),
  "alarm-cleared": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.2 17.6v-4.4a4.8 4.8 0 0 1 9.6 0v4.4" }),
    createElement("path", { "d": "M3.8 17.6h14.4" }),
    createElement("path", { "d": "m15.6 5.6 1.8 1.8 3.2-3.4" })
    )
  ),
  "alarm-triggered": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M7.2 17.6v-4.4a4.8 4.8 0 0 1 9.6 0v4.4" }),
    createElement("path", { "d": "M4.6 17.6h14.8" }),
    createElement("path", { "d": "M12 3.4v2.4M5.4 5.6 7 7.2M18.6 5.6 17 7.2" })
    )
  ),
  "alerts": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M18 9.4a6 6 0 1 0-12 0c0 5-2 6.4-2 6.4h16s-2-1.4-2-6.4Z" }),
    createElement("path", { "d": "M13.7 19.4a2 2 0 0 1-3.4 0" })
    )
  ),
  "appearance": () => (
    createElement("path", { "d": "M19.4 14.4A7.6 7.6 0 0 1 9.6 4.6a7.6 7.6 0 1 0 9.8 9.8Z" })
  ),
  "assign": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "M21 11.4h-6.2" }),
    createElement("path", { "d": "m17.6 8.6-2.8 2.8 2.8 2.8" })
    )
  ),
  "attention": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("path", { "d": "M12 7.6v5" }),
    createElement("circle", { "cx": "12", "cy": "16.3", "r": "1.05", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "avatar": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.8", "y": "3.8", "width": "16.4", "height": "16.4", "rx": "4" }),
    createElement("path", { "d": "m9 15.4 3-7 3 7" }),
    createElement("path", { "d": "M10.2 12.9h3.6" })
    )
  ),
  "avatar-anon": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.8", "y": "3.8", "width": "16.4", "height": "16.4", "rx": "4" }),
    createElement("circle", { "cx": "12", "cy": "10", "r": "2.7" }),
    createElement("path", { "d": "M6.8 20.2c.6-3 2.7-4.6 5.2-4.6s4.6 1.6 5.2 4.6" })
    )
  ),
  "back": () => (
    createElement("path", { "d": "m14 7-5 5 5 5" })
  ),
  "boundary": () => (
    createElement("rect", { "x": "4.6", "y": "4.6", "width": "14.8", "height": "14.8", "rx": "4.5", "strokeDasharray": "3.4 3.2" })
  ),
  "broadcast-all": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M14.6 5.2v13.6L6.4 15H4.6A1.6 1.6 0 0 1 3 13.4v-2.8A1.6 1.6 0 0 1 4.6 9h1.8Z" }),
    createElement("path", { "d": "M17.8 9.2a5 5 0 0 1 0 5.6" }),
    createElement("path", { "d": "M20.2 6.8a8.6 8.6 0 0 1 0 10.4" })
    )
  ),
  "broadcast-zone": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 7.4v-2a2 2 0 0 1 2-2h2M16.6 3.4h2a2 2 0 0 1 2 2v2M20.6 16.6v2a2 2 0 0 1-2 2h-2M7.4 20.6h-2a2 2 0 0 1-2-2v-2" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.4", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M14.9 9.1a4.1 4.1 0 0 1 0 5.8M9.1 14.9a4.1 4.1 0 0 1 0-5.8" })
    )
  ),
  "call": () => (
    createElement("path", { "d": "M8.1 4.2 9.7 7.4a1.4 1.4 0 0 1-.4 1.7l-1.5 1.2a13.6 13.6 0 0 0 6 6l1.2-1.5a1.4 1.4 0 0 1 1.7-.4l3.2 1.6a1.4 1.4 0 0 1 .8 1.5c-.3 1.6-1.6 2.8-3.2 2.7C10.3 19.8 4.2 13.7 3.8 6.5c-.1-1.6 1.1-2.9 2.7-3.1a1.4 1.4 0 0 1 1.6.8Z" })
  ),
  "call-active": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M8.1 4.2 9.7 7.4a1.4 1.4 0 0 1-.4 1.7l-1.5 1.2a13.6 13.6 0 0 0 6 6l1.2-1.5a1.4 1.4 0 0 1 1.7-.4l3.2 1.6a1.4 1.4 0 0 1 .8 1.5c-.3 1.6-1.6 2.8-3.2 2.7C10.3 19.8 4.2 13.7 3.8 6.5c-.1-1.6 1.1-2.9 2.7-3.1a1.4 1.4 0 0 1 1.6.8Z" }),
    createElement("path", { "d": "M16.6 4.4a5.2 5.2 0 0 1 2.9 2.9" }),
    createElement("path", { "d": "M16.9 7.8a2.3 2.3 0 0 1 1.2 1.2" })
    )
  ),
  "call-missed": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M8.1 4.2 9.7 7.4a1.4 1.4 0 0 1-.4 1.7l-1.5 1.2a13.6 13.6 0 0 0 6 6l1.2-1.5a1.4 1.4 0 0 1 1.7-.4l3.2 1.6a1.4 1.4 0 0 1 .8 1.5c-.3 1.6-1.6 2.8-3.2 2.7C10.3 19.8 4.2 13.7 3.8 6.5c-.1-1.6 1.1-2.9 2.7-3.1a1.4 1.4 0 0 1 1.6.8Z" }),
    createElement("path", { "d": "m16.2 3.6 4.4 4.4M20.6 3.6l-4.4 4.4" })
    )
  ),
  "capture": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.6", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M8.6 15.4a4.8 4.8 0 0 1 0-6.8M15.4 8.6a4.8 4.8 0 0 1 0 6.8M6 18a8.6 8.6 0 0 1 0-12M18 6a8.6 8.6 0 0 1 0 12" })
    )
  ),
  "capture-return": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12.6 12H4.2" }),
    createElement("path", { "d": "m8 8.2-3.8 3.8L8 15.8" }),
    createElement("path", { "d": "M14.6 7.6a6.2 6.2 0 0 1 0 8.8" }),
    createElement("path", { "d": "M17.4 5a10 10 0 0 1 0 14" })
    )
  ),
  "cert-expired": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "9.4", "r": "4.8" }),
    createElement("path", { "d": "m10.3 7.7 3.4 3.4M13.7 7.7l-3.4 3.4" }),
    createElement("path", { "d": "m9.2 13.6-1.5 6.8 4.3-2.5 4.3 2.5-1.5-6.8" })
    )
  ),
  "cert-expiring": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "9.4", "r": "4.8" }),
    createElement("path", { "d": "M12 7v2.9M12 12.1h.01" }),
    createElement("path", { "d": "m9.2 13.6-1.5 6.8 4.3-2.5 4.3 2.5-1.5-6.8" })
    )
  ),
  "cert-valid": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "9.4", "r": "4.8" }),
    createElement("path", { "d": "m9.9 9.4 1.5 1.5 2.7-2.9" }),
    createElement("path", { "d": "m9.2 13.6-1.5 6.8 4.3-2.5 4.3 2.5-1.5-6.8" })
    )
  ),
  "checkpoint": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 21s6-5.4 6-10a6 6 0 0 0-12 0c0 4.6 6 10 6 10Z" }),
    createElement("circle", { "cx": "12", "cy": "10.6", "r": "2.2" })
    )
  ),
  "clear-filters": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 5.4h12.4L11.2 11v4.9l-3.6 1.8V11Z" }),
    createElement("path", { "d": "m17.2 5 4 4M21.2 5l-4 4" })
    )
  ),
  "columns": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.4", "y": "4.6", "width": "17.2", "height": "14.8", "rx": "2" }),
    createElement("path", { "d": "M9.1 4.6v14.8M14.9 4.6v14.8" })
    )
  ),
  "command": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "4.6" }),
    createElement("path", { "d": "m12 12 5.6-5.6" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.2", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "contractor": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "8.8", "cy": "8.4", "r": "3.2" }),
    createElement("path", { "d": "M3.2 19.4c.7-3.3 2.9-5 5.6-5 1.6 0 3 .6 4 1.7" }),
    createElement("path", { "d": "M20.8 4.9a3 3 0 0 1-3.9 3.9l-3.2 3.2-1.7-1.7 3.2-3.2a3 3 0 0 1 3.9-3.9l-1.9 1.9 1.7 1.7Z" })
    )
  ),
  "critical": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.4 20.6 18a1.8 1.8 0 0 1-1.6 2.7H5a1.8 1.8 0 0 1-1.6-2.7L12 3.4Z" }),
    createElement("path", { "d": "M12 9.6v4.2" }),
    createElement("circle", { "cx": "12", "cy": "17", "r": "1.05", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "degraded": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.6", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M8.6 15.4a4.8 4.8 0 0 1 0-6.8M6 18a8.6 8.6 0 0 1 0-12" }),
    createElement("path", { "d": "M15.4 8.6a4.8 4.8 0 0 1 0 6.8", "strokeDasharray": "1.9 2.7" }),
    createElement("path", { "d": "M18 6a8.6 8.6 0 0 1 0 12", "strokeDasharray": "1.9 2.7" })
    )
  ),
  "density": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 6h10.4M4 12h10.4M4 18h10.4" }),
    createElement("path", { "d": "M18.8 5.2v13.6" }),
    createElement("path", { "d": "m16.4 7.6 2.4-2.4 2.4 2.4" }),
    createElement("path", { "d": "m16.4 16.4 2.4 2.4 2.4-2.4" })
    )
  ),
  "discard": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4.6 7h14.8M9.4 7V5.2h5.2V7M6.4 7l.9 12.4h9.4L17.6 7" }),
    createElement("path", { "d": "M10.2 10.4v5.6M13.8 10.4v5.6" })
    )
  ),
  "dispatch-queue": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M9.4 5.4h11.2M9.4 12h11.2M9.4 18.6h11.2" }),
    createElement("path", { "d": "M4.6 4.4v10.6" }),
    createElement("path", { "d": "m2.2 12.6 2.4 2.6 2.4-2.6" })
    )
  ),
  "dispatcher": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "9.8", "r": "3.4" }),
    createElement("path", { "d": "M6.8 9.8a5.2 5.2 0 0 1 10.4 0v1.8" }),
    createElement("path", { "d": "M17.2 11.6a2 2 0 0 1-2 2h-1.4" }),
    createElement("path", { "d": "M5.8 20.4c.8-3.4 3.2-5.2 6.2-5.2s5.4 1.8 6.2 5.2" })
    )
  ),
  "dnd": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M7.8 12h8.4" })
    )
  ),
  "doc": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.4 3.6h7.4l3.8 3.8v13H6.4Z" }),
    createElement("path", { "d": "M13.8 3.6v3.8h3.8" }),
    createElement("path", { "d": "M9 12h6M9 15.4h6" })
    )
  ),
  "door-propped": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M5.8 20.6V5.2a1.7 1.7 0 0 1 1.7-1.7h7a1.7 1.7 0 0 1 1.7 1.7v15.4" }),
    createElement("path", { "d": "M3.4 20.6h17.2" }),
    createElement("path", { "d": "M13.2 11.8h.01" }),
    createElement("path", { "d": "M14.6 20.6h4.6l-4.6-3.6Z", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "draft": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.4 3.6h7.4l3.8 3.8v13H6.4Z", "strokeDasharray": "2.9 2.7" }),
    createElement("path", { "d": "M13.8 3.6v3.8h3.8" })
    )
  ),
  "duty": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.2c2.6 1.6 5.4 2.4 8.2 2.8v5.4c0 5.4-3 9.6-8.2 12-5.2-2.4-8.2-6.6-8.2-12V6c2.8-.4 5.6-1.2 8.2-2.8Z" }),
    createElement("path", { "d": "m9 12.2 2.2 2.2 4-4.4" })
    )
  ),
  "edit": () => (
    createElement("path", { "d": "m4.6 19.4.9-3.6L16.2 5.1a1.9 1.9 0 0 1 2.7 2.7L8.2 18.5Z" })
  ),
  "email": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.4", "y": "5.4", "width": "17.2", "height": "13.2", "rx": "1.8" }),
    createElement("path", { "d": "m4.2 6.6 7.8 6.2 7.8-6.2" })
    )
  ),
  "en-route": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M8.6 12h6" }),
    createElement("path", { "d": "m12.2 9.4 2.6 2.6-2.6 2.6" })
    )
  ),
  "escalate": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 19.6h4.6V15h4.6v-4.6h3.2" }),
    createElement("path", { "d": "m14 10.4 6.4-6.4" }),
    createElement("path", { "d": "M14.6 3.4h6v6" })
    )
  ),
  "escort": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "8.6", "cy": "7.8", "r": "3.2" }),
    createElement("path", { "d": "M3 19.4c.7-3.3 2.9-5 5.6-5 1.2 0 2.3.3 3.2.9" }),
    createElement("path", { "d": "M18 9.4c1.1.6 2.2 1 3.2 1.1v2.6c0 2.5-1.3 4.4-3.2 5.4-1.9-1-3.2-2.9-3.2-5.4v-2.6c1-.1 2.1-.5 3.2-1.1Z" })
    )
  ),
  "eta": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "13.4", "r": "6.8" }),
    createElement("path", { "d": "M12 9.6v3.8l2.6 1.6" }),
    createElement("path", { "d": "M12 6.6V3.8M9.8 3.8h4.4" })
    )
  ),
  "expand": () => (
    createElement("path", { "d": "m7 10 5 5 5-5" })
  ),
  "export": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 4.4v9.8M8.2 10.6l3.8 3.6 3.8-3.6" }),
    createElement("path", { "d": "M4.6 16.4v2a1.6 1.6 0 0 0 1.6 1.6h11.6a1.6 1.6 0 0 0 1.6-1.6v-2" })
    )
  ),
  "export-csv": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.2 20.6V4.4h7.2l4.4 4.4v11.8Z" }),
    createElement("path", { "d": "M13.4 4.4v4.4h4.4" }),
    createElement("path", { "d": "M9.2 12.4v4.8M12 12.4v4.8M14.8 12.4v4.8" })
    )
  ),
  "export-pdf": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.2 20.6V4.4h7.2l4.4 4.4v11.8Z" }),
    createElement("path", { "d": "M13.4 4.4v4.4h4.4" }),
    createElement("path", { "d": "M9.2 12.6h5.6M9.2 15.2h5.6M9.2 17.8h3.2" })
    )
  ),
  "filter": () => (
    createElement("path", { "d": "M4 5.4h16L14.4 12v5.6l-4.8 2.4V12Z" })
  ),
  "fire": () => (
    createElement("path", { "d": "M12 3.6c2.8 3 6.2 5.9 6.2 9.8a6.2 6.2 0 0 1-12.4 0c0-2.4 1-4.3 2.6-6.2.4 1.2 1 2 1.9 2.7.3-2.4.6-4.2 1.7-6.3Z" })
  ),
  "group-by": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.4", "y": "4", "width": "9.6", "height": "4.8", "rx": "1.4" }),
    createElement("path", { "d": "M6 8.8v7.4a1.8 1.8 0 0 0 1.8 1.8h1.4" }),
    createElement("path", { "d": "M12.6 13.2h8M12.6 18h8" })
    )
  ),
  "handoff": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "6.8", "cy": "13", "r": "2.4" }),
    createElement("circle", { "cx": "17.2", "cy": "13", "r": "2.4" }),
    createElement("path", { "d": "M3.4 20.4a3.4 3.4 0 0 1 6.8 0M13.8 20.4a3.4 3.4 0 0 1 6.8 0" }),
    createElement("path", { "d": "M5.8 8.4A8.4 8.4 0 0 1 16.6 6.4" }),
    createElement("path", { "d": "M17 3.4v3.6h-3.6" })
    )
  ),
  "hazard-spill": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.4s4.6 5.2 4.6 8.2a4.6 4.6 0 0 1-9.2 0c0-3 4.6-8.2 4.6-8.2Z" }),
    createElement("path", { "d": "M3.4 19.8c1.4-1.2 2.9-1.2 4.3 0s2.9 1.2 4.3 0 2.9-1.2 4.3 0 2.9 1.2 4.3 0" })
    )
  ),
  "help": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("path", { "d": "M9.6 9.3a2.5 2.5 0 1 1 3.5 2.4c-.8.35-1.1.85-1.1 1.75" }),
    createElement("circle", { "cx": "12", "cy": "16.6", "r": "1", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "inbox": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 13.4 6 5.6h12l2.6 7.8" }),
    createElement("path", { "d": "M3.4 13.4V18a1.6 1.6 0 0 0 1.6 1.6h14a1.6 1.6 0 0 0 1.6-1.6v-4.6" }),
    createElement("path", { "d": "M3.4 13.4h4.8a3.8 3.8 0 0 0 7.6 0h4.8" })
    )
  ),
  "incidents": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.4 20.6 18a1.8 1.8 0 0 1-1.6 2.7H5a1.8 1.8 0 0 1-1.6-2.7L12 3.4Z" }),
    createElement("path", { "d": "M12 9.6v4.2" }),
    createElement("circle", { "cx": "12", "cy": "17", "r": "1.05", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "lock": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "5.4", "y": "10.4", "width": "13.2", "height": "9", "rx": "2" }),
    createElement("path", { "d": "M8.4 10.4V8a3.6 3.6 0 0 1 7.2 0v2.4" })
    )
  ),
  "lost-found": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M13 3.4 4.6 11.8a2.1 2.1 0 0 0 0 3l4.6 4.6a2.1 2.1 0 0 0 3 0l8.4-8.4V5.4a2 2 0 0 0-2-2Z" }),
    createElement("circle", { "cx": "16.4", "cy": "7.6", "r": "1.3" })
    )
  ),
  "maintenance": () => (
    createElement("path", { "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-8 8l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 8-8Z" })
  ),
  "manual": () => (
    createElement("path", { "d": "m4.6 19.4.9-3.6L16.2 5.1a1.9 1.9 0 0 1 2.7 2.7L8.2 18.5Z" })
  ),
  "map": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M9 4.2 3.6 6v13.6l5.4-1.8 6 1.8 5.4-1.8V4.2l-5.4 1.8L9 4.2Z" }),
    createElement("path", { "d": "M9 4.2v13.6M15 6v13.6" })
    )
  ),
  "map-unavailable": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 21s6-5.4 6-10a6 6 0 0 0-12 0c0 4.6 6 10 6 10Z" }),
    createElement("path", { "d": "M9.6 10.6h4.8" })
    )
  ),
  "medical": () => (
    createElement("path", { "d": "M9.6 3.4h4.8v6.2h6.2v4.8h-6.2v6.2H9.6v-6.2H3.4V9.6h6.2Z" })
  ),
  "message": () => (
    createElement("path", { "d": "M20.6 14.6a1.8 1.8 0 0 1-1.8 1.8H9l-4.6 4V6.2a1.8 1.8 0 0 1 1.8-1.8h12.6a1.8 1.8 0 0 1 1.8 1.8Z" })
  ),
  "message-unread": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M18.6 15a1.8 1.8 0 0 1-1.8 1.8H8.6l-4.4 3.8V6.6a1.8 1.8 0 0 1 1.8-1.8h10.8a1.8 1.8 0 0 1 1.8 1.8Z" }),
    createElement("circle", { "cx": "19.4", "cy": "5.2", "r": "2.4", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "more": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "5.4", "cy": "12", "r": "1.5", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.5", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "18.6", "cy": "12", "r": "1.5", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "mute": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "9.4", "y": "3.4", "width": "5.2", "height": "9.6", "rx": "2.6" }),
    createElement("path", { "d": "M6.4 11.2a5.6 5.6 0 0 0 11.2 0" }),
    createElement("path", { "d": "M12 16.8v3.2" }),
    createElement("path", { "d": "m4.4 4.4 15.2 15.2" })
    )
  ),
  "my-shift": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("path", { "d": "M12 7.4V12l3.2 2" })
    )
  ),
  "next": () => (
    createElement("path", { "d": "m10 7 5 5-5 5" })
  ),
  "nfc": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.6", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M8.6 15.4a4.8 4.8 0 0 1 0-6.8M15.4 8.6a4.8 4.8 0 0 1 0 6.8M6 18a8.6 8.6 0 0 1 0-12M18 6a8.6 8.6 0 0 1 0 12" })
    )
  ),
  "no-show": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "m9.2 9.2 5.6 5.6M14.8 9.2l-5.6 5.6" })
    )
  ),
  "noise": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 9.6v4.8h3.2l4.6 3.6V6L6.6 9.6Z" }),
    createElement("path", { "d": "M14.6 9.2a4.6 4.6 0 0 1 0 5.6" }),
    createElement("path", { "d": "M17.4 6.6a9 9 0 0 1 0 10.8" })
    )
  ),
  "notify-push": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "6.6", "y": "3.4", "width": "10.8", "height": "17.2", "rx": "2" }),
    createElement("rect", { "x": "8.8", "y": "6", "width": "6.4", "height": "3.2", "rx": "1" }),
    createElement("path", { "d": "M10.6 17.6h2.8" })
    )
  ),
  "off-duty": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M14.4 8.4a4.4 4.4 0 1 0 1.6 6 3.4 3.4 0 0 1-1.6-6Z" })
    )
  ),
  "officer": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "8.6", "r": "3.6" }),
    createElement("path", { "d": "M5.4 19.6c.8-3.6 3.4-5.4 6.6-5.4s5.8 1.8 6.6 5.4" })
    )
  ),
  "offline": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.6", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "M8.6 15.4a4.8 4.8 0 0 1 0-6.8M6 18a8.6 8.6 0 0 1 0-12" }),
    createElement("path", { "d": "M15.4 8.6a4.8 4.8 0 0 1 0 6.8", "strokeDasharray": "1.9 2.7" }),
    createElement("path", { "d": "M18 6a8.6 8.6 0 0 1 0 12", "strokeDasharray": "1.9 2.7" })
    )
  ),
  "on-break": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M10.2 9.2v5.6M13.8 9.2v5.6" })
    )
  ),
  "on-duty": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "2.6", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "on-scene": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6 20.6V3.8" }),
    createElement("path", { "d": "M6 4.6h9.8l-2.4 3.2 2.4 3.2H6" })
    )
  ),
  "overflow": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "6", "r": "1.4", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.4", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "18", "r": "1.4", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "overtime": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "10.4", "cy": "12.6", "r": "6.6" }),
    createElement("path", { "d": "M10.4 9v3.6l2.4 1.5" }),
    createElement("path", { "d": "M19 4.6v5M16.5 7.1h5" })
    )
  ),
  "page-first": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4.6 5.4v13.2" }),
    createElement("path", { "d": "m14.6 6.6-5.4 5.4 5.4 5.4" })
    )
  ),
  "page-last": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M19.4 5.4v13.2" }),
    createElement("path", { "d": "m9.4 6.6 5.4 5.4-5.4 5.4" })
    )
  ),
  "page-next": () => (
    createElement("path", { "d": "m9.8 6.6 5.4 5.4-5.4 5.4" })
  ),
  "page-prev": () => (
    createElement("path", { "d": "m14.2 6.6-5.4 5.4 5.4 5.4" })
  ),
  "patrols": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.2c2.6 1.6 5.4 2.4 8.2 2.8v5.4c0 5.4-3 9.6-8.2 12-5.2-2.4-8.2-6.6-8.2-12V6c2.8-.4 5.6-1.2 8.2-2.8Z" }),
    createElement("path", { "d": "m9 12.2 2.2 2.2 4-4.4" })
    )
  ),
  "person-add": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "M18.6 9.4v6.4M15.4 12.6h6.4" })
    )
  ),
  "person-remove": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "M15.4 12.6h6.4" })
    )
  ),
  "pin-column": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.4", "y": "4.4", "width": "5.2", "height": "15.2", "rx": "1.2" }),
    createElement("path", { "d": "m14.6 4.8 4.6 4.6-2.9.9-.7 3.2-2.5-2.5-2.5-2.5 3.1-.8Z" }),
    createElement("path", { "d": "M12.4 11.6 9.6 14.4" })
    )
  ),
  "platform": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.4 20.6 8 12 12.6 3.4 8 12 3.4Z" }),
    createElement("path", { "d": "m3.4 12.4 8.6 4.6 8.6-4.6" }),
    createElement("path", { "d": "m3.4 16.6 8.6 4.6 8.6-4.6" })
    )
  ),
  "plus": () => (
    createElement("path", { "d": "M12 5.4v13.2M5.4 12h13.2" })
  ),
  "print": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M7 8.6V4.4h10v4.2" }),
    createElement("path", { "d": "M6.2 16.6H4.8A1.8 1.8 0 0 1 3 14.8v-4.4a1.8 1.8 0 0 1 1.8-1.8h14.4A1.8 1.8 0 0 1 21 10.4v4.4a1.8 1.8 0 0 1-1.8 1.8h-1.4" }),
    createElement("rect", { "x": "6.2", "y": "13.6", "width": "11.6", "height": "6", "rx": "1" }),
    createElement("path", { "d": "M17.6 11.4h.01" })
    )
  ),
  "profile": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.6" }),
    createElement("circle", { "cx": "12", "cy": "9.9", "r": "2.7" }),
    createElement("path", { "d": "M6.9 18.3c1-2.6 2.9-3.9 5.1-3.9s4.1 1.3 5.1 3.9" })
    )
  ),
  "proof": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("path", { "d": "m8.3 12.4 2.5 2.5 4.9-5.3" })
    )
  ),
  "proof-check": () => (
    createElement("path", { "d": "m5.5 12.5 4.2 4.2 8.8-9.4" })
  ),
  "publish": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "m4.4 11 15.2-6.6L13 19.6l-2.2-6.4Z" }),
    createElement("path", { "d": "M19.6 4.4 10.8 13.2" })
    )
  ),
  "qr": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "4", "y": "4", "width": "6.4", "height": "6.4", "rx": "1" }),
    createElement("rect", { "x": "13.6", "y": "4", "width": "6.4", "height": "6.4", "rx": "1" }),
    createElement("rect", { "x": "4", "y": "13.6", "width": "6.4", "height": "6.4", "rx": "1" }),
    createElement("path", { "d": "M13.6 13.6h2.8v2.8h-2.8ZM17.2 17.2h2.8v2.8h-2.8Z" })
    )
  ),
  "radio": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "6.6", "y": "7.4", "width": "10.8", "height": "13.2", "rx": "1.8" }),
    createElement("path", { "d": "M9.6 7.4v-4" }),
    createElement("path", { "d": "M9.4 11h5.2M9.4 14.6h5.2" })
    )
  ),
  "radio-channel": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 10.6v9.8" }),
    createElement("circle", { "cx": "12", "cy": "8.2", "r": "1.6" }),
    createElement("path", { "d": "M7.2 3.8a9.6 9.6 0 0 0 0 8.8M16.8 3.8a9.6 9.6 0 0 1 0 8.8" }),
    createElement("path", { "d": "M9.5 6a5.4 5.4 0 0 0 0 4.4M14.5 6a5.4 5.4 0 0 1 0 4.4" })
    )
  ),
  "receipt": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M6.4 3.6h11.2v15.8l-1.9-1.3-1.8 1.3-1.9-1.3-1.9 1.3-1.8-1.3-1.9 1.3Z" }),
    createElement("path", { "d": "m9.1 10.2 2 2 3.8-4" })
    )
  ),
  "recenter": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "6" }),
    createElement("path", { "d": "M12 2.6v3.2M12 18.2v3.2M2.6 12h3.2M18.2 12h3.2" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.4", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "refresh": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M19.8 12a7.8 7.8 0 1 1-2.3-5.5L19.8 8" }),
    createElement("path", { "d": "M20 3.8v3.6h-3.6" })
    )
  ),
  "replay": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.4" }),
    createElement("path", { "d": "M12 12 17.4 5.6" }),
    createElement("path", { "d": "M14.2 7.2A5.3 5.3 0 0 0 8.6 7.9" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "1.35", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "8", "cy": "14.3", "r": "1.1", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "replay-pause": () => (
    createElement("path", { "d": "M8.6 6.2v11.6M15.4 6.2v11.6" })
  ),
  "replay-play": () => (
    createElement("path", { "d": "M9 6.2v11.6l9.2-5.8Z" })
  ),
  "reports": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4.6 19.4h14.8" }),
    createElement("path", { "d": "M8 19.4v-6.4M12.2 19.4V8.2M16.4 19.4v-8.8" })
    )
  ),
  "retire": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "4", "y": "4.6", "width": "16", "height": "4.4", "rx": "1.2" }),
    createElement("path", { "d": "M5.6 9v9.2a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V9" }),
    createElement("path", { "d": "M10 12.6h4" })
    )
  ),
  "review": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "10.6", "cy": "10.6", "r": "5.8" }),
    createElement("path", { "d": "m15 15 4.6 4.6" }),
    createElement("path", { "d": "M8.2 10.6h4.8" })
    )
  ),
  "row-expand": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 4.6h16M4 19.4h16" }),
    createElement("path", { "d": "m8.4 10.2 3.6 3.6 3.6-3.6" })
    )
  ),
  "row-select": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "4.4", "y": "4.4", "width": "15.2", "height": "15.2", "rx": "3" }),
    createElement("path", { "d": "m8.4 12.2 2.6 2.6 4.8-5.2" })
    )
  ),
  "row-select-all": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M8 3.6h9.2a3.2 3.2 0 0 1 3.2 3.2V16" }),
    createElement("rect", { "x": "3.6", "y": "7.6", "width": "12.8", "height": "12.8", "rx": "2.6" }),
    createElement("path", { "d": "m7 14 2.2 2.2 4-4.4" })
    )
  ),
  "saved-view": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M7 4.4h10v15.2l-5-3.6-5 3.6Z" }),
    createElement("path", { "d": "M9.8 8.6h4.4" })
    )
  ),
  "schedule": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.6", "y": "5", "width": "16.8", "height": "15", "rx": "2" }),
    createElement("path", { "d": "M3.6 9.6h16.8M8 3.2v3.4M16 3.2v3.4" })
    )
  ),
  "schedule-shift": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.6", "y": "5", "width": "16.8", "height": "15", "rx": "2" }),
    createElement("path", { "d": "M3.6 9.6h16.8M8 3.2v3.4M16 3.2v3.4" }),
    createElement("path", { "d": "M12 12.2v4.6M9.7 14.5h4.6" })
    )
  ),
  "search": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "10.8", "cy": "10.8", "r": "6.3" }),
    createElement("path", { "d": "m15.6 15.6 4.4 4.4" })
    )
  ),
  "send": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "m4.4 11 15.2-6.6L13 19.6l-2.2-6.4Z" }),
    createElement("path", { "d": "M19.6 4.4 10.8 13.2" })
    )
  ),
  "settings": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 7.2h8.4M17.6 7.2h2.4M4 16.8h2.4M11.6 16.8h8.4" }),
    createElement("circle", { "cx": "15", "cy": "7.2", "r": "2.2" }),
    createElement("circle", { "cx": "9", "cy": "16.8", "r": "2.2" })
    )
  ),
  "setup": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 7.2h8.4M17.6 7.2h2.4M4 16.8h2.4M11.6 16.8h8.4" }),
    createElement("circle", { "cx": "15", "cy": "7.2", "r": "2.2" }),
    createElement("circle", { "cx": "9", "cy": "16.8", "r": "2.2" })
    )
  ),
  "shift-swap": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.6 8.2h13.2" }),
    createElement("path", { "d": "m13.6 4.8 3.4 3.4-3.4 3.4" }),
    createElement("path", { "d": "M20.4 15.8H7.2" }),
    createElement("path", { "d": "m10.6 12.4-3.4 3.4 3.4 3.4" })
    )
  ),
  "sign-out": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M9.4 4.6H5.8a1.6 1.6 0 0 0-1.6 1.6v11.6a1.6 1.6 0 0 0 1.6 1.6h3.6" }),
    createElement("path", { "d": "m15.4 15.8 3.8-3.8-3.8-3.8M19 12H9.4" })
    )
  ),
  "sms": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M20.6 14.6a1.8 1.8 0 0 1-1.8 1.8H9l-4.6 4V6.2a1.8 1.8 0 0 1 1.8-1.8h12.6a1.8 1.8 0 0 1 1.8 1.8Z" }),
    createElement("circle", { "cx": "8.6", "cy": "10.8", "r": "1", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "12.4", "cy": "10.8", "r": "1", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "16.2", "cy": "10.8", "r": "1", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "sort-asc": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 6.4h3.6M4 12h6.6M4 17.6h9.6" }),
    createElement("path", { "d": "M17.6 16.8V7.4" }),
    createElement("path", { "d": "m14.6 10.2 3-3 3 3" })
    )
  ),
  "sort-desc": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 6.4h9.6M4 12h6.6M4 17.6h3.6" }),
    createElement("path", { "d": "M17.6 7.2v9.4" }),
    createElement("path", { "d": "m14.6 13.8 3 3 3-3" })
    )
  ),
  "sort-none": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4 6.4h8M4 12h8M4 17.6h8" }),
    createElement("path", { "d": "m14.8 8.6 3-3 3 3" }),
    createElement("path", { "d": "m14.8 15.4 3 3 3-3" })
    )
  ),
  "sort-time": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.4", "cy": "12", "r": "6" }),
    createElement("path", { "d": "M9.4 8.8V12l2.3 1.5" }),
    createElement("path", { "d": "M18.8 8v8" }),
    createElement("path", { "d": "m16.4 13.6 2.4 2.4 2.4-2.4" })
    )
  ),
  "sos": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 3.4 20.6 18a1.8 1.8 0 0 1-1.6 2.7H5a1.8 1.8 0 0 1-1.6-2.7L12 3.4Z" }),
    createElement("path", { "d": "M12 9.6v4.2" }),
    createElement("circle", { "cx": "12", "cy": "17", "r": "1.05", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "sun": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "4.2" }),
    createElement("path", { "d": "M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.4 5.4l1.7 1.7M16.9 16.9l1.7 1.7M18.6 5.4l-1.7 1.7M7.1 16.9l-1.7 1.7" })
    )
  ),
  "supervisor": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "m15.4 8.2 3-3 3 3" }),
    createElement("path", { "d": "m15.4 12.8 3-3 3 3" })
    )
  ),
  "suspicious-person": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9", "cy": "7.8", "r": "3.2" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 2.9-5 5.6-5 1.5 0 2.9.5 3.9 1.4" }),
    createElement("path", { "d": "M16.2 9.2a2.7 2.7 0 1 1 3.8 2.5c-.9.4-1.4 1-1.4 2" }),
    createElement("path", { "d": "M18.6 17h.01" })
    )
  ),
  "suspicious-vehicle": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M3.4 16.4v-2.6l1.3-3.6a1.8 1.8 0 0 1 1.7-1.2h5.2a1.8 1.8 0 0 1 1.7 1.2l1.3 3.6v2.6" }),
    createElement("path", { "d": "M3.4 16.4h11.2" }),
    createElement("circle", { "cx": "6.6", "cy": "18.2", "r": "1.7" }),
    createElement("circle", { "cx": "11.4", "cy": "18.2", "r": "1.7" }),
    createElement("path", { "d": "M17.4 6.2a2.6 2.6 0 1 1 3.6 2.4c-.8.4-1.3 1-1.3 1.9" }),
    createElement("path", { "d": "M19.7 13.6h.01" })
    )
  ),
  "sync": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M4.6 9.4a7.8 7.8 0 0 1 13-2.9l1.6 1.5" }),
    createElement("path", { "d": "M19.4 4.4V8h-3.6" }),
    createElement("path", { "d": "M19.4 14.6a7.8 7.8 0 0 1-13 2.9L4.8 16" }),
    createElement("path", { "d": "M4.6 19.6V16h3.6" })
    )
  ),
  "team": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "8.6", "r": "3.1" }),
    createElement("path", { "d": "M6.9 19.8c.7-3.1 2.7-4.7 5.1-4.7s4.4 1.6 5.1 4.7" }),
    createElement("path", { "d": "M17.3 5.8a2.5 2.5 0 0 1 .1 4.8M20.9 18c-.4-2.2-1.6-3.6-3.4-4.1" }),
    createElement("path", { "d": "M6.7 5.8a2.5 2.5 0 0 0-.1 4.8M3.1 18c.4-2.2 1.6-3.6 3.4-4.1" })
    )
  ),
  "theft": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.4", "y": "6.6", "width": "17.2", "height": "12.6", "rx": "1.8" }),
    createElement("path", { "d": "M20.6 10.8h-4a1.8 1.8 0 0 0 0 3.6h4" }),
    createElement("path", { "d": "M17.9 12.6h.01" })
    )
  ),
  "time-off": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.8", "y": "5.2", "width": "16.4", "height": "14.6", "rx": "2" }),
    createElement("path", { "d": "M8.4 3.4v3.6M15.6 3.4v3.6M3.8 10.2h16.4" }),
    createElement("path", { "d": "m10.2 13.2 3.6 3.6M13.8 13.2l-3.6 3.6" })
    )
  ),
  "trespass": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M8.2 3.8v3M8.2 10.5v3M8.2 17.2v3" }),
    createElement("path", { "d": "M3.4 12H19" }),
    createElement("path", { "d": "m15.8 8.6 3.4 3.4-3.4 3.4" })
    )
  ),
  "unassign": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "9.2", "cy": "8.4", "r": "3.3" }),
    createElement("path", { "d": "M3.4 19.4c.7-3.3 3-5 5.8-5s5.1 1.7 5.8 5" }),
    createElement("path", { "d": "M14.8 11.4H21" }),
    createElement("path", { "d": "m18.2 8.6 2.8 2.8-2.8 2.8" })
    )
  ),
  "unauthorized-access": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "4.4", "y": "10.6", "width": "10.4", "height": "9", "rx": "1.8" }),
    createElement("path", { "d": "M6.8 10.6V8a3.4 3.4 0 0 1 6.3-1.8" }),
    createElement("path", { "d": "M9.6 14.2v1.8" }),
    createElement("path", { "d": "m17.4 4.2 3.8 3.8M21.2 4.2l-3.8 3.8" })
    )
  ),
  "unavailable": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M6.2 17.8 17.8 6.2" })
    )
  ),
  "unclassified": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "8.2" }),
    createElement("path", { "d": "M9.6 9.5a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1.1.9-1.1 1.7" }),
    createElement("path", { "d": "M12 17h.01" })
    )
  ),
  "unmute": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "9.4", "y": "3.4", "width": "5.2", "height": "9.6", "rx": "2.6" }),
    createElement("path", { "d": "M6.4 11.2a5.6 5.6 0 0 0 11.2 0" }),
    createElement("path", { "d": "M12 16.8v3.2" })
    )
  ),
  "vandalism": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "4.4", "y": "4.4", "width": "15.2", "height": "15.2", "rx": "1.4" }),
    createElement("path", { "d": "m11.2 4.4-1.6 4.2 3.6 2.2-2.6 3.8 1.8 4.8" })
    )
  ),
  "weather": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M7 15.4h10.4a3.3 3.3 0 0 0 .6-6.6 5.2 5.2 0 0 0-10.2-1.1A4 4 0 0 0 7 15.4Z" }),
    createElement("path", { "d": "m12.4 15.4-1.8 3h2.6l-2 3.2" })
    )
  ),
  "week": () => (
    createElement(Fragment, null,
    createElement("rect", { "x": "3.6", "y": "5", "width": "16.8", "height": "15", "rx": "2" }),
    createElement("path", { "d": "M3.6 9.6h16.8M8 3.2v3.4M16 3.2v3.4" }),
    createElement("rect", { "x": "6.4", "y": "12.2", "width": "11.2", "height": "3.4", "rx": "1.1", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "welfare-check": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 20.4S4.2 15.5 4.2 10A4.2 4.2 0 0 1 12 7.8 4.2 4.2 0 0 1 19.8 10c0 5.5-7.8 10.4-7.8 10.4Z" }),
    createElement("path", { "d": "m9.4 11.2 1.9 1.9 3.3-3.6" })
    )
  ),
  "x": () => (
    createElement("path", { "d": "m6.5 6.5 11 11M17.5 6.5l-11 11" })
  ),
  "pin-me": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "9.6", "fill": "currentColor", "opacity": "0.18", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "4.6", "fill": "currentColor", "stroke": "var(--pin-core, #ffffff)", "strokeWidth": "2.2" })
    )
  ),
  "pin-route": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "9.6", "fill": "currentColor", "opacity": "0.22", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "12", "r": "6.6", "fill": "currentColor", "stroke": "none" })
    )
  ),
  "pin-scanned": () => (
    createElement(Fragment, null,
    createElement("circle", { "cx": "12", "cy": "12", "r": "7.4", "fill": "currentColor", "stroke": "none" }),
    createElement("path", { "d": "m8.7 12.2 2.2 2.2 4.4-4.7", "fill": "none", "stroke": "var(--pin-core, #ffffff)", "strokeWidth": "2.1", "strokeLinecap": "round", "strokeLinejoin": "round" })
    )
  ),
  "pin-selected": () => (
    createElement(Fragment, null,
    createElement("path", { "d": "M12 22.2s-7-6.2-7-11.4a7 7 0 1 1 14 0c0 5.2-7 11.4-7 11.4Z", "fill": "currentColor", "stroke": "none" }),
    createElement("circle", { "cx": "12", "cy": "10.6", "r": "2.5", "fill": "var(--pin-core, #ffffff)", "stroke": "none" })
    )
  ),
};
